import React from 'react';

import { HubPropTypes } from 'dpl/prismic/utils/customPropTypes';
import { getArticlePath } from 'dpl/prismic/utils';
import Icon from 'dpl/common/components/Icon';

export default function ViewAllLink({ hubPage }) {
  return (
    <div className="PrismicViewAllLink inline-flex align-items-center fw-medium purple">
      <a className="mr1" href={getArticlePath(hubPage)}>
        View all
      </a>
      <Icon name="lined-arrow-right" />
    </div>
  );
}

ViewAllLink.propTypes = {
  hubPage: HubPropTypes.isRequired
};
